export default {
  HOST: window.location.hostname,
  PORT: 1150
};
